import React, {useState} from "react";
import DatePicker, {registerLocale} from "react-datepicker";
import el from "date-fns/locale/el";
import en from "date-fns/locale/en-IN";
import "./index.css";
import "react-datepicker/dist/react-datepicker.css";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import moment from "moment";
import {isEmpty} from "../../../_helpers/commonFunctions";

registerLocale("el", el);
registerLocale("en", en);

// Use this if we want week to start on Sunday
const customEL = {
    ...el,
    options: { ...el.options, weekStartsOn: 0 },
}
registerLocale("customEL", customEL);

const DateBox = ({id, name, classes, label, selected, required, dateFormat, language, minDate,
                     maxDate, placeholder, allowOlderDate, readOnly, showMonthYearPicker, onChange,
                     disabled, customInput, showWeekPicker, showWeekNumbers, allowOtherYears}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [date, setDate] = useState(new Date());
    let selectedValue = null;

    if (selected && selected === 'today') {
        selectedValue = date;
    } else if (selected && selected !== 'today') {
        selectedValue = selected;
    }

    const handleOnChange = (e) => {
        if (String(e?.getFullYear()) !== String(company.year) && !allowOtherYears) { // Do not allow other years
            toast.error(`Παρακαλώ επιλέξτε ημερομηνία εντός της χρονιάς που είστε συνδεδεμένοι (${company.year}).`);
            if (String(name).includes("from")) {
                onChange && onChange(moment(String(company.year)).startOf("year").toDate());
            } else if (String(name).includes("to")) {
                onChange && onChange(moment(String(company.year)).endOf("year").toDate());
            } else {
                onChange && onChange("");
            }
        }else if (e === null || e === undefined || e === "") {
            setDate(e)
            onChange && onChange(e)
        } else {
            setDate(e)
            onChange && onChange(e)
        }
    }

    const handleOnBlur = () => {
        if (isEmpty(date) || !moment(date).isValid()) { // Invalid date
            onChange && onChange("");
        } else if (String(date?.getFullYear()) !== String(company.year) && !allowOtherYears) { // Do not allow other years
            toast.error(`Παρακαλώ επιλέξτε ημερομηνία εντός της χρονιάς που είστε συνδεδεμένοι (${company.year}).`);
            if(String(name).includes("from")) {
                onChange && onChange(moment(String(company.year)).startOf("year").toDate());
            } else if(String(name).includes("to")) {
                onChange && onChange(moment(String(company.year)).endOf("year").toDate());
            } else {
                onChange && onChange("");
            }
        }
    }

    const onChangeRaw = (e) => {
        const value = e.target.value;

        // 6 digits (010124) or 8 digits (01012024)
        if (/^\d{6}$|^\d{8}$/.test(value)) {
            const formats = ["DDMMYY", "DDMMYYYY"];
            const mDate = moment(value, formats, true);

            if (mDate.isValid()) handleOnChange(mDate.toDate());
        }
    }

    return (
        <div className={`input-container ${classes ? classes : ""}`}>
            {label && (
                <label htmlFor={id} className="input-label mb-2">
                    {label}{" "}
                    {required && <span className="text-danger">*</span>}
                </label>
            )}
            <div className="input-wrapper">
                <DatePicker
                    id={id}
                    name={name ? name : ""}
                    dateFormat={dateFormat ? dateFormat : ["dd-MM-yyyy", "dd/MM/yyyy", "ddMMyyyy", "ddMMyy"]}
                    locale={language ? language : "el"}
                    minDate={minDate ? minDate : new Date("01-01-2010")}
                    maxDate={maxDate ? maxDate : new Date("31-12-2030")}
                    selected={selectedValue}
                    placeholderText={placeholder}
                    readOnly={allowOlderDate !== true ? readOnly : ""}
                    autoComplete="off"
                    showMonthYearPicker={showMonthYearPicker}
                    onChange={(e) => handleOnChange(e)}
                    onChangeRaw={(e) => onChangeRaw(e)}
                    onBlur={(e) => handleOnBlur(e)}
                    className={"form-control " + classes}
                    disabled={disabled}
                    wrapperClassName={"datepicker-full-width"}
                    customInput={customInput}
                    showWeekPicker={showWeekPicker}
                    showWeekNumbers={showWeekNumbers}
                />
            </div>
        </div>
    )
}

export default DateBox;
